import type { AlertProps } from '@/types/alert'

const useShowAlert = () => useState('showAlert', () => false)
const useAlert = () => useState('alert', () => <AlertProps>({ title: '', message: '', active: false }))

export { useShowAlert, useAlert }
